import React, { CSSProperties } from 'react';
import cc from 'classcat';
import C from './IconImg.css';

export default function IncomImg(p: {
  src?: string;
  className?: string;
  style?: CSSProperties;
}) {
  return (
    <img
      src={p.src}
      className={cc([C.img, p.className])}
      style={p.style}
      draggable={false}
    />
  );
}
